import * as React from "react";



export class ControlBase <Prop extends ControlBaseProps,State extends ControlBaseState> extends React.Component<Prop, State> {
    static defaultProps: Partial<ControlBaseProps> = {};
    private _propertiesToMonitor;
    constructor(props: Prop, context?: any) {
        super(props, context);
    }

    public render() {
        return (
            null
        )
    }

    public componentWillReceiveProps(nextProps: Readonly<Prop>, nextContext: any): void {
        if(typeof this._propertiesToMonitor=="undefined")
            return;
        for(let propertyName of this._propertiesToMonitor) {
            if(typeof nextProps[propertyName]=="undefined")
                continue;
            if (typeof this.props[propertyName]=="undefined"|| nextProps[propertyName] != this.props[propertyName])
                this[propertyName + 'Changing'](nextProps[propertyName], nextProps);
        }
    }

    public RegisterMethodForChangingEvent(methodName:string){
        (this as any)._propertiesToMonitor=[];
        (this as any)._propertiesToMonitor.push(methodName.replace('Changing',''));
    }

    componentDidMount(){
        if(typeof this._propertiesToMonitor=="undefined")
            return;
        for(let propertyName of this._propertiesToMonitor) {
            if(typeof this.props[propertyName]!="undefined")
            {
                this[propertyName + 'Changing'](this.props[propertyName],this.props);
            }
        }
    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface ControlBaseProps {

}

export interface ControlBaseState {

}

//#endregion "My Region"
